import React, { FC } from "react";
import { Skeleton as BaseSkeleton, SkeletonProps as BaseSkeletonProps, BoxProps } from "@chakra-ui/react";
import { useTheme } from "@workshop/ui";

export interface SkeletonProps extends BaseSkeletonProps {
  loadingStyle?: BoxProps;
}

const Skeleton: FC<SkeletonProps> = ({ isLoaded, loadingStyle, children, ...rest }) => {
  const theme = useTheme();
  return (
    <BaseSkeleton
      isLoaded={isLoaded}
      startColor={theme.colors.lightGrey}
      endColor={theme.colors.medGrey}
      borderRadius="md"
      {...rest}
      {...(isLoaded ? {} : loadingStyle)}
    >
      {children}
    </BaseSkeleton>
  );
};

export default Skeleton;
